export const styles = {
    saveIcon: {
        marginRight: 8,
        width: 16,
        '& g': {
            stroke: 'white'
        }
    }
};
